export default __webpack_public_path__ + "static/media/List-documentation.54b4a370.md";